//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    ratings: {
      type: [Array, Object],
      default: () => [],
    },
  },
  data() {
    return {
      rates: [
        {
          key: '5',
          label: this._('Отлично'),
          icon: 'dashboard_new',
        },
        {
          key: '4',
          label: this._('Хорошо'),
          icon: 'dashboard_in_work',
        },
        {
          key: '3',
          label: this._('Нормально'),
          icon: 'dashboard_processing',
        },
        {
          key: '2',
          label: this._('Так себе'),
          icon: 'dashboard_success',
        },
        {
          key: '1',
          label: this._('Плохо'),
          icon: 'dashboard_failed',
        },
      ],
    }
  },
  computed: {
    ratingsData() {
      return this.ratings.slice().sort((a, b) => b.stars - a.stars);
    },
    totalReviews() {
      return this.ratings.reduce((sum, rating) => sum + rating.count, 0);
    },
    maxCount() {
      return Math.max(...this.ratings.map(r => r.count));
    },
    averageRating() {
      const totalScore = this.ratings.reduce((sum, rating) => sum + (rating.stars * rating.count), 0);
      return totalScore / this.totalReviews;
    },
    // overallPercentage() {
    //   const positiveReviews = this.ratings
    //     .filter(r => 4 <= r.stars)
    //     .reduce((sum, rating) => sum + rating.count, 0);

    //   return this.ratings
    // },
  },
  methods: {
    getStarClass() {
      return this.averageRating;
    },

    getProgressWidth(count) {
      return (count / this.maxCount) * 100;
    },
    getVal(list = [], val) {
      const base = this.rate(list, val) || 0
      const total = this.rate(list, 'total') || 0
      return Math.floor((base / total) * 100) || 0
    },
    rate(list = [], val) {
      return list.find(({ title }) => title === val)?.value || 0
    },
  },
};
